module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-bg"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('div', {
    staticClass: "animated fadeInRight "
  }, [_c('HeaderBase'), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content"
  }, [_c('router-view', {
    staticClass: " "
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-012583de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layout.vue
// module id = 434
// module chunks = 1